/*
 * Copyright (c) 2020. American Express Company
 */

import { combineReducers } from 'redux';
import user from './user';

export default combineReducers({ user });
